import type { PaginationMetadata } from '@shared/api/generated/model'

export class ApiContractError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ApiContractError'
  }
}

export function requireEnvelopeData<T>(
  envelope: { data?: T | null },
  resourceName: string,
): T {
  if (envelope.data === undefined || envelope.data === null) {
    throw new ApiContractError(`Resposta inválida da API para ${resourceName}.`)
  }

  return envelope.data
}

function toSafeInteger(value: number | string | undefined, fallback: number) {
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : fallback
}

export function toFiniteNumber(value: number | string | undefined, fallback = 0) {
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export function normalizePagination(
  pagination: PaginationMetadata | undefined,
  defaults: { page: number; limit: number },
) {
  return {
    page: toSafeInteger(pagination?.page, defaults.page),
    limit: toSafeInteger(pagination?.limit, defaults.limit),
    total: toSafeInteger(pagination?.total, 0),
    totalPages: toSafeInteger(pagination?.totalPages, 0),
  }
}

export function requiredString(value: string | null | undefined, fieldName: string) {
  if (typeof value !== 'string' || !value.trim()) {
    throw new ApiContractError(`Campo obrigatório ausente na resposta da API: ${fieldName}.`)
  }

  return value
}
